// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage_error__AE9vt","img":"ErrorMessage_img__pvCYy"};